<div v-if="access" :ref="elementId">
	<div class="grid-2">
		<input-frame :id="`title-${elementId}`" v-model="access.name"
			:label="$t('vm.root.user.office.access.name.label')"
			:placeholder="$t('vm.root.user.office.access.name.placeholder')"
			:error-test="hasNameError" :error-msg="$t('vm.root.user.office.access.name.error-msg')"
			:title="$t('vm.root.user.office.access.name.title')"/>

		<dropdown-frame id="type" v-model="access.type" :items="typeItems"
			:title="$t('vm.root.user.office.access.type.title')"
			:label="$t('vm.root.user.office.access.type.label')"/>

		<dropdown-frame v-if="hasLine" class="grid-item-full" id="line" v-model="access.line" :items="lineItems"
			:title="$t('vm.root.user.office.access.line.title')"
			:label="$t('vm.root.user.office.access.line.label')" />

		<textarea-frame :id="`description-${elementId}`" class="grid-item-full" rows="2" v-model="access.description"
			:label="$tc('vm.root.user.office.access.description.label', messageLength)"
			:error-test="messageWarning" :error-msg="$t('vm.root.user.office.access.description.msg-error')"
			:placeholder="$t('vm.root.user.office.access.description.placeholder')"
			:title="$t('vm.root.user.office.access.description.title')"/>
	</div>

	<div class="text-right">
		<delete-item class="btn--link-like text-danger" :can-delete="true"
			:title="$t('vm.root.user.office.access.delete.title')"
			:delete-msg="$t('vm.root.user.office.access.delete.msg')"
			:delete-action="deleteAccess">
			<svg width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
				<use xlink:href="@Assets/svg/symbol-defs.svg#trash-alt"/>
			</svg>
			{{ $t('general.delete.text') }}
		</delete-item>
	</div>
</div>
